export function redirectToHttpsIfNot() {
  const isHttps = window.location.protocol === 'https:';
  if (!isHttps) window.location.replace(`https:${window.location.href.substring(window.location.protocol.length)}`);
}